module.exports = __webpack_public_path__ + "static/newLOGO-6be1b26738e768291d9b3871d62e5d9e.png";